import Vue from "vue";

const GLOBAL_EVENT_PREFIX = "g:";

export const EventBus = new Vue({
	methods: {
		pushGlobalEvent(name, e) {
			// console.log("GLOBAL EVENT", name, e);
			this.$emit(GLOBAL_EVENT_PREFIX + name, e);
		},
		onGlobalEvent(name, e) {
			this.$on(GLOBAL_EVENT_PREFIX + name, e);
		},
		onSingleGlobalEvent(name, e) {
			this.$once(GLOBAL_EVENT_PREFIX + name, e);
		},

		onGlobalEventWithTimeout(name, e, fun, refobj, timeout = 50000) {
			this.$on(GLOBAL_EVENT_PREFIX + name, e);
			this.fun = fun;
			this.refobj = refobj;
			var that = this;
			setTimeout(function() {
				that.$off(GLOBAL_EVENT_PREFIX + name, e);
				that.fun(that.refobj);
			}, timeout);
		}
		// TODO: setup a way to remove global event listeners?
	}
});
